import { post } from 'utils/sdk.ts';

export const sendForgotPasswordEmail = ({ email }: { email: string }) =>
  post<{ email: string }>('api/v2/auth/send-forgot-password-email/', { email });
